module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_data_lake-fec9cf5be36d985c857ff6b0b78c5431.png";